import { IRoute } from '../../utils/navigation/routes';
import Login from './Login';
import LoginApp from './LoginApp';
import LoginCallback from './LoginCallback';
import LoginHelp from './LoginHelp';
import LoginHelpSignUp from './LoginHelpSignUp';
import LoginMobileConnect from './LoginMobileConnect';
import LoginMobileConnectCallback from './LoginMobileConnectCallback';
import LoginSSO from './LoginSSO';
import LoginSSOCallback from './LoginSSOCallback';

export const loginRoutes: IRoute[] = [
    { path: '/login', element: <Login /> },
    { path: '/login/callback', element: <LoginCallback /> },
    { path: '/login/app', element: <LoginApp /> },
    { path: '/login/sso', element: <LoginSSO /> },
    { path: '/login/sso/callback', element: <LoginSSOCallback /> },
    { path: '/login/mc', element: <LoginMobileConnect /> },
    { path: '/login/mc/callback', element: <LoginMobileConnectCallback /> },
    { path: '/login/help-with-access', element: <LoginHelp /> },
    { path: '/login/help-with-access/sign-up', element: <LoginHelpSignUp /> },
];
